
function NotFound () {
    return(
        <li className="not-found">
            <h2>No results found</h2>
            <p>We didn't find any results, Try Again</p>
        </li>
    )
}

export default NotFound;